import useGetHeaderSize from "../../hooks/useGetHeaderSize";
import FullMenu from "./FullMenu";
import BurgerMenu from "./BurgerMenu";

const Header = () => {
  const { showFullHeader } = useGetHeaderSize();

  return <div>{showFullHeader ? <FullMenu /> : <BurgerMenu />}</div>;
};

export default Header;
